"use strict";

/**
 * Anything ordered by academic year and, optionally, the period within that year.
 * @typedef {{ year: number, period?: number }} YearAndPeriod
 */

export const PeriodUtils = {
  /**
   * Orders periods (or plain years) the same way everywhere: newest year first,
   * and within a year the highest period first. Returns a new array.
   * @template {YearAndPeriod} T
   * @param {readonly T[]} items
   * @returns {T[]}
   */
  sortNewestFirst(items) {
    return [...items].sort(
      (a, b) => b.year - a.year || (b.period ?? 0) - (a.period ?? 0)
    );
  },

  /**
   * The period that contains `now`, independent of display order. When several do (a whole
   * year and its first period), the one that starts last, then the one that ends last.
   * @template {{ startDate: number, endDate: number }} T
   * @param {readonly T[]} periods
   * @param {number} [now]
   * @returns {T | undefined}
   */
  findCurrent(periods, now = Date.now()) {
    return (periods ?? [])
      .filter((period) => period.startDate <= now && now <= period.endDate)
      .sort((a, b) => b.startDate - a.startDate || b.endDate - a.endDate)[0];
  }
};
